import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Input, Select, Card, Tag, Icon } from 'antd'

@inject((store: any) => {
    const { popupStore, termCollectionsStore } = store
    return { popupStore, termCollectionsStore }
})
@observer
export default class TermCollection extends Component<any, any> {
    state: any = {
        errors: {}
    }

    handleUpdate = async () => {
        await this.props.termCollectionsStore.update()
        this.closePopup()
    }

    closePopup = () => {
        this.props.termCollectionsStore.resetEdit()
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const { popupStore } = this.props
        const { loading, edit, changeValue, update, resetEdit } = this.props.termCollectionsStore
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
                <Button type="primary" disabled={loading} onClick={() => this.handleUpdate()}>
                    {loading ? <Icon type="loading" /> : ''}
                    שמור שינויים
                </Button>
            </div>
        )
        return (
            <Modal
                title={`עריכת שיוך פוליסה ${edit.policy_id}`}
                visible={popupStore.popupType === 'termCollection'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <label>
                    <strong>השתתפות עצמית</strong>
                </label>
                <Input
                    placeholder="עריכת השתתפות עצמית"
                    value={edit.deductible}
                    onChange={e => changeValue('deductible', e.target.value)}
                />
            </Modal>
        )
    }
}
